import { render, staticRenderFns } from "./my-profile-verification.vue?vue&type=template&id=2283a90a&scoped=true"
import script from "./my-profile-verification.vue?vue&type=script&lang=js"
export * from "./my-profile-verification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283a90a",
  null
  
)

export default component.exports